import Cookies from "js-cookie";

// Set a cookie
export const setCookie = (key, value, days = 7) => {
  Cookies.set(key, value, { expires: days, path: "/" });
};

// Get a cookie
export const getCookie = (key) => {
  const value = Cookies.get(key);
  return value ? value : null;
};

// Remove a cookie
export const removeCookie = (key) => {
  Cookies.remove(key, { path: "/" });
};
